module.exports = __webpack_public_path__ + "static/media/delete.58739bb1.svg";